<template>
  <div class="bottom_nav">
    <ul>
      <li
        v-for="(item,index) in list"
        :key="index"
        :class="{'active':currentIndex == index}"
        @click="hrfeaa(item.id,index)"
      >
        <a :href="item.id">{{item.name}}</a>
      </li>
    </ul>
    <!-- <span></span> -->
  </div>
</template>

<script>
export default {
  name: "Bottom",
  components: {},
  data() {
    return {
      currentIndex: null,
      list: [
        { name: "报告发布", id: "#official" },
        { name: "直播讲座", id: "#live" },
        { name: "院校咨询", id: "#school" },
        //{ name: "大咖咨询", id: "#expert" },
        { name: "顾问咨询", id: "#teacher" },
        { name: "抽奖专区", id: "#prize" }
      ]
    };
  },
  methods:{
    hrfeaa(id,index){
      this.currentIndex = index;
      window.location.href = id
    }
  }
};
</script>

<style scoped>
.bottom_nav {
  width: 100%;
  height: 1.3rem;
  border-radius: 0.4rem 0.4rem 0 0;
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 99;
}
.bottom_nav ul {
  padding: 0.17rem 0.25rem;
}
.bottom_nav ul li {
  display: inline-block;
  width: 1rem;
  height: 0.2rem;
  font-size: 0.24rem;
  text-align: center;
  margin: 0 0.2rem;
  padding-top: 0.6rem;
}
.bottom_nav ul li:nth-child(1) {
  background: url(~@/assets/images/bottom_icon0.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(1).active {
  background: url(~@/assets/images/bottom_icon0_on.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(2) {
  background: url(~@/assets/images/bottom_icon1.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(2).active {
  background: url(~@/assets/images/bottom_icon1_on.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(3) {
  background: url(~@/assets/images/bottom_icon2.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(3).active {
  background: url(~@/assets/images/bottom_icon2_on.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(4) {
  background: url(~@/assets/images/bottom_icon3.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(4).active {
  background: url(~@/assets/images/bottom_icon3_on.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(5) {
  background: url(~@/assets/images/bottom_icon4.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav ul li:nth-child(5).active {
  background: url(~@/assets/images/bottom_icon4_on.png) center top no-repeat;
  background-size: 0.54rem 0.54rem;
}
.bottom_nav span {
  display: block;
  width: 3rem;
  height: 0.08rem;
  background: #000;
  border-radius: 0.04rem;
  margin: 0.28rem auto 0;
}
</style>